//todo refactor

import { utils } from 'pixi.js';

import { events } from '../components/events';
import { config } from '../config/config';
import { isMobile } from './features';

export const resizeEmitter = new utils.EventEmitter();

const container = document.querySelector('.canvas-container') as HTMLElement;
let resizeRequest: any;

export interface ResizerDimensions {
  containerH: number;
  containerR: number;
  containerW: number;
  maxR: number;
  minR: number;
  scale: number;
  stageH: number;
  stageW: number;
  stageX: number;
  stageY: number;
  winW: number;
  winH: number;
}

export const dimensions = <ResizerDimensions>{};

export const initResize = () => {
  if (isMobile) {
    document.body.classList.add('mobile');
  }

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(delayedResize);
    resizeObserver.observe(document.body);
  } else {
    // @ts-ignore
    window.addEventListener('resize', delayedResize);
    // @ts-ignore
    window.addEventListener('orientationchange', delayedResize);
  }
  onWinResize();

  return resizeEmitter;
};

function delayedResize() {
  if (resizeRequest) {
    clearTimeout(resizeRequest);
  }
  resizeRequest = setTimeout(onWinResize, 100);
}

let checkInsideOutside = true;

const onWinResize = () => {
  if (container.classList.contains('cropped-canvas')) {
    container.classList.remove('cropped-canvas');
  }
  dimensions.winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  dimensions.winH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  document.documentElement.style.setProperty('--vh', `${dimensions.winH * 0.01}px`); //https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

  dimensions.containerW = container.offsetWidth;
  dimensions.containerH = container.offsetHeight;

  dimensions.containerR = dimensions.containerW / dimensions.containerH;

  dimensions.maxR = config.SIZES.MAX_WIDTH / config.SIZES.MAX_HEIGHT;
  dimensions.minR = config.SIZES.MIN_WIDTH / config.SIZES.MIN_HEIGHT;

  dimensions.scale = Math.min(1, dimensions.containerH / config.SIZES.MAX_HEIGHT);

  // todo remove checkInsideOutside hack
  if (checkInsideOutside) {
    if (dimensions.containerR < dimensions.winW / dimensions.winH && dimensions.scale < 1) {
      if (!document.body.classList.contains('inside')) {
        document.body.classList.add('inside');
        checkInsideOutside = false;
        delayedResize();
        return;
      }
    } else {
      if (document.body.classList.contains('inside')) {
        document.body.classList.remove('inside');
        checkInsideOutside = false;
        delayedResize();
        return;
      }
    }
  }

  checkInsideOutside = true;

  dimensions.stageW = config.SIZES.MAX_WIDTH * dimensions.scale;
  dimensions.stageH = config.SIZES.MAX_HEIGHT * dimensions.scale;

  //shift to center stage in container after rescale
  dimensions.stageX = dimensions.containerW / 2 - dimensions.stageW / 2;
  dimensions.stageY = dimensions.containerH / 2 - dimensions.stageH / 2;

  resizeEmitter.emit(events.RESIZE, dimensions);

  if (document.body.classList.contains('inside')) {
    container.classList.add('cropped-canvas');
  }
  if (!document.body.classList.contains('inside')) {
    container.classList.remove('cropped-canvas');
  }
};
